import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import VideoPlayer from '../components/VideoPlayer';

const FilmDetail = () => {
  const { id } = useParams();
  const [film, setFilm] = useState(null);
  const [relatedProject, setRelatedProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/films/${id}`)
      .then(res => res.json())
      .then(data => {
        if (data) {
          setFilm(data);

          if (data.projectId) {
            fetch(`${process.env.REACT_APP_API_URL}/projects/${data.projectId}`)
              .then(res => res.json())
              .then(projectData => setRelatedProject(projectData))
              .catch(err => console.error('Erreur projet:', err));
          }
        }
      })
      .catch(err => console.error('Erreur film:', err))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-12 flex justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-amber-500"></div>
      </div>
    );
  }

  if (!film) {
    return (
      <div className="container mx-auto px-4 py-12">
        <div className="bg-red-50 border-l-4 border-red-500 p-4">
          <p className="text-red-700">Film non trouvé. Ce film n'existe pas ou a été supprimé.</p>
        </div>
        <div className="mt-6">
          <Link to="/" className="text-amber-600 hover:text-amber-700 flex items-center">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-2">{film.title}</h1>
      <div className="flex items-center text-gray-600 text-sm mb-4">
        {film.director && <span className="mr-4">Réalisé par {film.director}</span>}
        {film.genre && <span className="mr-4">{film.genre}</span>}
        {film.duration && (
          <span>
            {Math.floor(film.duration / 60)}h{film.duration % 60 > 0 ? ` ${film.duration % 60}min` : ''}
          </span>
        )}
      </div>

      <VideoPlayer videoUrl={film.videoUrl} poster={film.poster} title={film.title} />

      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-xl font-bold mb-4">Synopsis</h2>
        <p className="text-gray-700">{film.synopsis}</p>
      </div>

      {relatedProject && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-6">
          <h2 className="text-xl font-bold mb-4">Projet associé</h2>
          <h3 className="text-lg font-bold mb-2">{relatedProject.title}</h3>
          <p className="text-sm text-gray-600 mb-3">
            {relatedProject.director ? `Par ${relatedProject.director}` : ''}
          </p>
          <p className="text-gray-700 mb-4">{relatedProject.description}</p>

          <div className="mb-4">
            <div className="flex justify-between text-sm mb-1">
              <span className="font-medium">
                {Math.round((relatedProject.raised / relatedProject.goal) * 100)}% financé
              </span>
              <span>
                {relatedProject.raised.toLocaleString()} FCFA sur {relatedProject.goal.toLocaleString()} FCFA
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5">
              <div
                className="bg-amber-500 h-2.5 rounded-full"
                style={{ width: `${Math.min(Math.round((relatedProject.raised / relatedProject.goal) * 100), 100)}%` }}
              ></div>
            </div>
          </div>

          <Link to={`/projets/${relatedProject.id}`}>
            <button className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-2 rounded-full text-sm font-medium transition">
              Contribuer au projet
            </button>
          </Link>
        </div>
      )}

      <div className="mt-8">
        <Link to="/" className="text-amber-600 hover:text-amber-700 flex items-center">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default FilmDetail;
